import { render, staticRenderFns } from "./DashboardTodaysReservations.vue?vue&type=template&id=2bcc73ee&scoped=true&"
import script from "./DashboardTodaysReservations.vue?vue&type=script&lang=js&"
export * from "./DashboardTodaysReservations.vue?vue&type=script&lang=js&"
import style0 from "./DashboardTodaysReservations.vue?vue&type=style&index=0&id=2bcc73ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bcc73ee",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/ui/DashboardTodaysReservations.vue
// module id = null
// module chunks = 